module.exports = __webpack_public_path__ + "img/fengniao.7b7414b2.png";